import Masonry from 'masonry-layout'

const masonryInit = () => {
    const container = document.querySelector('.newsoverview');
    if(container) {
        window.addEventListener('load', () => {
            createMasonry(container);
        })
    }
}

const createMasonry = (container) => {
    new Masonry(container, {
        itemSelector: '.newsoverview-item',
        horizontalOrder: true
    })
}

document.addEventListener('DOMContentLoaded', masonryInit);